// @flow
import {type User} from './types';

export const selectPrimary = (u: User) => u.profiles.find(p => p.isPrimary) || u.profiles[0];
